import { handleApiCall } from '@/apiClient'
import { JSON_HEADERS } from '@/services/headers'

export interface CreateDiaryEntryBody {
  date: string
  symptom: string
  triptanUsed?: boolean
  painkillerUsed?: boolean
  impactScore?: number | null
  notes?: string
}

const DiaryService = {
  async getEntries() {
    return handleApiCall('/patientPortal/diary/entries', {
      method: 'GET',
      headers: JSON_HEADERS,
    })
  },

  async saveEntry(entry: CreateDiaryEntryBody) {
    return handleApiCall('/patientPortal/diary/entry/submit', {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(entry),
    })
  },
}

export default DiaryService
